interface Props {
  fill?: string;
  width?: string;
  height?: string;
  stroke?: string;
  className?: string;
}

const PlusCircle = ({
  fill = 'none',
  stroke = '#231f20',
  height = '6.5845971mm',
  width = '6.5846mm',
  className,
}: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="svg2004"
    version="1.1"
    viewBox="0 0 6.5846 6.5845971"
    height={height}
    width={width}
    className={className}
  >
    <g transform="translate(-98.761274,-82.13032)">
      <path
        d="m 105.08129,85.422793 c 0,1.67217 -1.35573,3.02754 -3.02754,3.02754 -1.67217,0 -3.027893,-1.35537 -3.027893,-3.02754 0,-1.67216 1.355723,-3.02789 3.027893,-3.02789 1.67181,0 3.02754,1.35573 3.02754,3.02789 z"
        style={{
          fill,
          stroke: fill === 'none' ? stroke : fill,
          strokeWidth: 0.4,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 'none',
          strokeOpacity: 1,
        }}
        id="path702"
      />
      <path
        d="m 102.05375,84.189763 v 2.46592"
        style={{
          fill,
          stroke,
          strokeWidth: 0.4,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 'none',
          strokeOpacity: 1,
        }}
        id="path706"
      />
      <path
        d="m 103.28674,85.422793 h -2.46591"
        style={{
          fill,
          stroke,
          strokeWidth: 0.4,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 'none',
          strokeOpacity: 1,
        }}
        id="path710"
      />
    </g>
  </svg>
);

export default PlusCircle;
